import axios from 'axios';

const state= {
  sorRecurringModes: []
};

const getters = {
  sorRecurringModes : (state) => state.sorRecurringModes,
};

const actions = {

  async getListSorRecurringModes({commit}, params){
    return new Promise (( resolve, reject ) => {
        global.axios(`api/sor-recurring-modes`, {
            method: "GET",
            headers: {
              Accept: "application/json",
            }
        })
        .then(response => {
          if(response.data.status == 200) {
            commit('setSorRecurringModes', response.data.data)
          }
          resolve( response );
        })
        .catch(error => reject( error ));
    });
  },
  async createSorRecurringModes({commit}, params){

    return new Promise (( resolve, reject ) => {
      global.axios(`api/sor-recurring-modes`, {
        method: "POST",
        data:  params,
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
          commit('updateListSorRecurringModes',response)
          resolve( response );
      })
      .catch(error => reject( error ));
    });
  },
}; 

const mutations = {
  setSorRecurringModes(state, data) {
    state.sorRecurringModes = data
  },
  updateListSorRecurringModes(state, data) {
    state.sorRecurringModes =  [...state.sorRecurringModes , data.data.data];
  }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}